module.exports = __webpack_public_path__ + "static/media/war_icon_v1.892daec7.svg";